import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent {

  constructor(public dialog: MatDialog) { }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/request-quote/success/success.component.ts